import React, { useState } from 'react';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubscribe = (event) => {
    event.preventDefault();

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailPattern.test(email.trim())) {
      setMessage('Enter a valid email address.');
      return;
    }

    setMessage('Subscribed successfully.');
    setEmail('');
  };

  return (
    <footer className="footerSection">
      <div className="subscribeSection">
        <p className="sectionLabel">Newsletter</p>
        <h2>Subscribe for updates and offers</h2>
        <p>Includes basic email validation to show frontend form handling.</p>

        <form className="subscribeForm" onSubmit={handleSubscribe}>
          <input
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            placeholder="Enter your email address"
          />
          <button type="submit">Subscribe</button>
        </form>
        {message ? <p className="subscribeMessage">{message}</p> : null}
      </div>

      <div className="downloadSection">
        <p className="sectionLabel">Project Highlights</p>
        <h2>Why this project is stronger now</h2>
        <ul className="footerHighlights">
          <li>Cart quantity controls and remove action</li>
          <li>Sorting, search, category filters, and empty states</li>
          <li>Product details modal and toast notifications</li>
          <li>Persistent cart with localStorage</li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
